module.exports = __webpack_public_path__ + "img/07.59bb9838.png";